module.exports = __webpack_public_path__ + "static/img/t15.07046d12.png";